import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'app',
  initialState: {
    error: null,
    bottomSheetOpen: false,
    selectedCallsign: '',
    intersectingCallsigns: [],
    intersectingCallsignData: null,
    loading: true,
    bufferInMeters: 1609.34,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBottomSheetOpen: (state, action) => {
      state.bottomSheetOpen = action.payload;
    },
    setSelectedCallsign: (state, action) => {
      state.selectedCallsign = action.payload;
    },
    setIntersectingCallsigns: (state, action) => {
      state.intersectingCallsigns = action.payload;
    },
    setIntersectingCallsignData: (state, action) => {
      state.intersectingCallsignData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setBufferInMeters: (state, action) => {
      state.bufferInMeters = action.payload;
    },
  },
});

export default slice.reducer;

export const setError = (payload) => ({ type: 'app/setError', payload });
export const setBottomSheetOpen = (payload) => ({
  type: 'app/setBottomSheetOpen',
  payload,
});
export const setSelectedCallsign = (payload) => ({
  type: 'app/setSelectedCallsign',
  payload,
});
export const setIntersectingCallsigns = (payload) => ({
  type: 'app/setIntersectingCallsigns',
  payload,
});
export const setLoading = (payload) => ({
  type: 'app/setLoading',
  payload,
});
export const setBufferInMeters = (payload) => ({
  type: 'app/setBufferInMeters',
  payload,
});
export const setIntersectingCallsignData = (payload) => ({
  type: 'app/setIntersectingCallsignData',
  payload,
});
